module.exports = __webpack_public_path__ + "static/media/fullsoft.3371da8f.jpg";